import React from 'react';
import { Award, Lock, BarChart3, Clock } from 'lucide-react';
import { ScrollReveal, ScrollRevealStagger, ScrollRevealItem } from './ScrollReveal';
import './why-trust-us.css';

const reasons = [
  {
    icon: Award,
    title: 'Trusted expertise',
    desc: 'Years of experience guiding salaried professionals toward confident financial decisions.',
    accent: '#c9920a',
  },
  {
    icon: Lock,
    title: 'Secure platform',
    desc: 'Your data and transactions are protected with industry-grade security and compliance.',
    accent: '#319595',
  },
  {
    icon: BarChart3,
    title: 'Transparent insights',
    desc: 'Clear terms, honest rates, and straightforward communication at every step.',
    accent: '#00b4d8',
  },
  {
    icon: Clock,
    title: '24/7 support',
    desc: 'Dedicated assistance whenever you need help with your application or repayment.',
    accent: '#319595',
  },
];

const WhyTrustUs = () => {
  return (
    <section className="wtu-wrap" aria-labelledby="wtu-title">
      <div className="wtu-layout">
        <ScrollReveal className="wtu-intro" y={28}>
          <span className="wtu-eyebrow">Why choose us</span>
          <h2 id="wtu-title" className="wtu-title">
            Built on trust, <span>designed for you</span>
          </h2>
          <p className="wtu-lead">
            We combine RBI-regulated lending with a digital-first experience — so you always know where
            you stand and who stands behind your loan.
          </p>
        </ScrollReveal>

        <ScrollRevealStagger className="wtu-bento" stagger={0.1}>
          {reasons.map(({ icon: Icon, title, desc, accent }, i) => (
            <ScrollRevealItem
              key={title}
              className={`wtu-tile wtu-tile--${i + 1}`}
              as="article"
            >
              <span className="wtu-tile-icon" style={{ '--wtu-accent': accent }}>
                <Icon size={22} strokeWidth={2.5} aria-hidden />
              </span>
              <h3>{title}</h3>
              <p>{desc}</p>
            </ScrollRevealItem>
          ))}
        </ScrollRevealStagger>
      </div>
    </section>
  );
};

export default WhyTrustUs;
